module.exports = __webpack_public_path__ + "img/recover.cbda3ea5.svg";